export const copyLink = (link) =>{

    if(link.indexOf(window.location.hostname)){
        copyText(window.location.protocol + '//' + window.location.hostname + link );
    } else {
        copyText( link );
    }

};

export const copyText = (text) => {

    const textField = document.createElement('textarea');

    textField.value = text;

    document.body.appendChild(textField);
    try {
        textField.select();
        return document.execCommand('copy');
    } finally {
        textField.remove();
    }

}
